import { HashLink } from 'react-router-hash-link';


function AiChatbot() {
  return (
    <div className="bg-projects2 absolute top-0 left-0 min-h-screen w-full bg-gray-100 flex flex-col items-center justify-start px-4 sm:px-8 scroll-mt-[80px] -mt-[80px]">
      
      <div className="w-full max-w-4xl mx-auto pt-2">
        <HashLink
            smooth
            to="/#resume-prof-projects"
            className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
        >
            <span className="mr-1">←</span> Go back to Home
        </HashLink>
      </div>

      <div className="max-w-4xl w-full bg-white rounded-xl shadow-lg p-6 sm:p-10 space-y-6">
        <h1 className="text-4xl font-bold title-color mb-2">Knowledge-Based AI Chatbot (Pilot, Phase 1)</h1>
        <h2 className="text-lg font-medium mb-1">Data Scientist, Capco Technologies Pvt. Ltd. (Data Capability)</h2>
        <p className="text-sm text-gray-600 mb-4">May 2023 – Jun 2024 | Internal Project</p>

        <p className="text-base mb-6">
          Built a domain-specific AI chatbot using LLaMA, LangChain, and Retrieval-Augmented Generation (RAG) to support
          structured financial data querying across multiple BFSI organizations. The project enhanced accuracy and
          responsiveness of financial insight delivery while ensuring enterprise-readiness for compliance-sensitive usage.
        </p>

        <ul className="list-disc list-inside space-y-3 mb-8 text-base">
          <li>
            Designed a knowledge-based chatbot using <strong>LLaMA, LangChain, RAG, and ChromaDB</strong> to enable structured
            financial query handling across 3 BFSI organizations.
          </li>
          <li>
            Implemented a <strong>bi-directional LSTM-based query router</strong> for intelligent dispatch across scheduling,
            insights, and factual agents—cutting response latency by approximately <strong>35%</strong>.
          </li>
          <li>
            Fine-tuned <strong>LLM inference parameters</strong> (temperature, top-k) to boost answer contextuality and accuracy
            by <strong>28%</strong> based on benchmark results and pilot feedback.
          </li>
          <li>
            Reduced manual document lookup by <strong>65%</strong> through conversational search that enabled rapid retrieval
            of structured financial insights.
          </li>
          <li>
            Integrated <strong>anti-profanity filter</strong> and compliance middleware ensuring <strong>zero flagged
            incidents</strong> during internal regulatory testing.
          </li>
          <li>
            Documented full system architecture and opened up GitHub documentation to facilitate <strong>cross-team
            contributions</strong> from 3 internal groups.
          </li>
          <li>
            Delivered the pilot to project leads, successfully completing Phase 1 and establishing foundation for scalable
            deployment across regulatory workflows.
          </li>
        </ul>

      </div>
    </div>
  );
}
  
  export default AiChatbot;  